export const DriverType = [
    {label: 'Driver Type', value: 'DEFAULT'},
    {label: 'Licensed National Tour Guide', value: 'LICENSED_NATIONAL_TOUR_GUIDE'},
    {label: 'Licensed Tourist Driver', value: 'LICENSED_TOURIST_DRIVER'},
    {label: 'Private Chauffeur Guide', value: 'PRIVATE_CHAUFFEUR_GUIDE'},
    {label: 'Standard Driver', value: 'STANDARD_DRIVER'}
];